import "./healthSafetyTheme.css";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { canAccessHealthSafety } from "@/constants/nav";

export default function HealthSafetyWorkspace() {
  const { user } = useAuth();
  return canAccessHealthSafety(user) ? <div className="hs-theme"><Outlet /></div> : <Navigate to="/app" replace />;
}
